import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectUserDetails } from '../service/slices/authSlice';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export const ProtectedRoute = ({
  children,
  allowedRoles = ['admin', 'department', 'operation', 'recruiter']
}: ProtectedRouteProps) => {
  const userDetail = useSelector(selectUserDetails);

  if (userDetail) {
    const group = userDetail?.group as [];
    const hasAccess = group.some((role) => allowedRoles.includes(role));

    if (!hasAccess) {
      return <Navigate to="/" />;
    }
    return <>{children}</>;
  }
  return <Navigate to="/" />;
};
